import React, { useEffect, useRef, useState, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import Home from '../Components/Home'
import GlobalReach from '../Components/GlobalReach'
import ProductOffering from '../Components/ProductOffering'
import Testimonial from '../Components/Testimonial'
import Assembly from '../Components/Assembly'
import Team from '../Components/Team'
import JoinTeam from '../Components/JoinTeam'
import Gallery from '../Components/Gallery'
import Contact from '../Components/Contact'
import LogoSwiper from '../Components/LogoSwiper'

const DureWebsite = () => {
  const location = useLocation();
  const globalReachRef = useRef(null);
  const [showScrollMouse, setShowScrollMouse] = useState(true);

  // Handle scrolling to target section when navigating from another page
  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      // Wait for page to render, then scroll
      setTimeout(() => {
        const element = document.getElementById(target);
        if (element) {
          const offset = 70; // Same as ScrollLink offset
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
      // Clear the state to prevent scrolling on every render
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // Optimize scroll handler with requestAnimationFrame
  const scrollFrameRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!globalReachRef.current) return;
      
      if (scrollFrameRef.current === null) {
        scrollFrameRef.current = requestAnimationFrame(() => {
          const bottomOfGlobalReach =
            globalReachRef.current.offsetTop + globalReachRef.current.offsetHeight;

          if (window.scrollY > bottomOfGlobalReach - 50) {
            setShowScrollMouse(false); // fade OUT
          } else {
            setShowScrollMouse(true); // fade IN when above
          }
          scrollFrameRef.current = null;
        });
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollFrameRef.current !== null) {
        cancelAnimationFrame(scrollFrameRef.current);
      }
    };
  }, []);

  return (
    <div>
      <Home showScrollMouse={showScrollMouse} />
      <div ref={globalReachRef}>
        <GlobalReach />
      </div>
      <LogoSwiper />
      <ProductOffering />
      <Testimonial />
      <Assembly />
      <Team />
      <JoinTeam />
      <Gallery />
      <Contact />
    </div>
  );
}

export default DureWebsite